import { ContactStatus, ContactWorkflowStatus, IContact } from '../../../entities/contact'
import { ContactTypeSelectorSegment } from '../configs'

const profilingRequestPendingStatuses = new Set<ContactWorkflowStatus>([
  ContactWorkflowStatus.Draft,
  ContactWorkflowStatus.New,
  ContactWorkflowStatus.WIP,
  ContactWorkflowStatus.Rejected,
])

export interface ContactListFilterContext {
  modifiedBy: string
  partnerId: string
  appSource?: string
}

type ContactListFilter = (contacts: IContact[], context: ContactListFilterContext) => IContact[]

export const CONTACT_LIST_FILTERS: Record<ContactTypeSelectorSegment, ContactListFilter> = {
  [ContactTypeSelectorSegment.SelectedPartner]: (contacts, context) =>
    contacts.filter((contact) => contact.partnerId === context.partnerId),

  [ContactTypeSelectorSegment.AllContacts]: (contacts) => contacts,

  [ContactTypeSelectorSegment.MyRequest]: (contacts, context) =>
    contacts.filter((contact) => contact.modifiedBy === context.modifiedBy),

  [ContactTypeSelectorSegment.NewContacts]: (contacts) =>
    contacts.filter((contact) => contact.contactId.startsWith('new-')),

  [ContactTypeSelectorSegment.Inactive]: (contacts) =>
    contacts.filter((contact) => contact.status === ContactStatus.Inactive),

  [ContactTypeSelectorSegment.ProfilingRequests]: (contacts) =>
    contacts.filter(
      (contact) =>
        contact.workflowStatus != null &&
        profilingRequestPendingStatuses.has(contact.workflowStatus)
    ),
}
